import {
  CheckDeliveryDateSelectableRequest,
  CheckDeliveryDateSelectableResponse,
  GuestDeliveryDatesResponse,
  GuestDeliveryDatesOrderType,
  GuestDeliveryDatesSubscriptionType,
  GuestDeliveryDatesAddonPlanType,
} from "@delivery-dates/types";
import { BaseAPI } from "@utils/base-api";
import { Dayjs } from "dayjs";
import { DeliveryDateProductType, DeliveryDateOrderType } from "@/primary-models";

export class DeliveryDatesAPI extends BaseAPI {

  public async checkDeliveryDateSelectable(
    deliveryDate: Dayjs,
    productType?: DeliveryDateProductType,
    orderType?: DeliveryDateOrderType
  ): Promise<CheckDeliveryDateSelectableResponse> {
    const request: CheckDeliveryDateSelectableRequest = {
      deliveryDate,
      productType,
      orderType,
    };

    const response = await this.axios.post<CheckDeliveryDateSelectableResponse>("check-selectable", request);
    return response.data;
  }

  public async getGuestDeliveryDates(
    orderType?: GuestDeliveryDatesOrderType,
    numberOfDays?: number,
    subscriptionType?: GuestDeliveryDatesSubscriptionType,
    addonPlanType?: GuestDeliveryDatesAddonPlanType,
  ): Promise<GuestDeliveryDatesResponse> {
    const params = new URLSearchParams();
    if (orderType) params.set("orderType", orderType);
    if (numberOfDays !== undefined) params.set("numberOfDays", numberOfDays.toString());
    if (subscriptionType) params.set("subscriptionType", subscriptionType);
    if (addonPlanType) params.set("addonPlanType", addonPlanType);
    const response = await this.axios.get<GuestDeliveryDatesResponse>("available/guest", { params });
    return response.data;
  }

}
